// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_RuT","cls2":"NewsHeader-cls2_58o NewsHeader-cls1_RuT"};